import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import {
    selectIsFeatureEnabled,
    useSelectIsFeatureEnabled,
} from 'app/store/featureToggles/selectors';
import { getTopic, topics } from 'widgets/myPortfolioCapsules/topics/Topic';
import State from 'store/State';
import { useSelector } from 'react-redux';

export function useIsTopicFeatureToggleEnabled() {
    const { config } = useMyPortfolioCapsulesConfigSlice();
    const featureToggle = config.topic
        ? getTopic(config.topic).featureToggle ?? ''
        : '';
    const featureToggleEnabled = useSelectIsFeatureEnabled(featureToggle);
    return featureToggle === '' || featureToggleEnabled;
}

export function useAvailableTopics() {
    return useSelector((state: State) => {
        return topics.filter(
            (t) =>
                !t.featureToggle ||
                selectIsFeatureEnabled(state, t.featureToggle)
        );
    });
}
